import React, {Component, Fragment} from 'react';
import {Card, Form, FormFeedback, FormGroup, Input, Label} from 'reactstrap';
import withValidator from '../../models/form/withValidator';
import LoadingButton from '../../../shared/ui/LoadingButton';
import Checkbox from "../../../shared/forms/Checkbox";

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    prompt: {
      rules: [
        {
          feedback: 'Prompt is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    checkoffPrompt: {
      rules: [],
    },
    requireAckResponse: {
      rules: []
    },
    isNotRequired: {
      rules: []
    }
  },
};

class CheckoffFormCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {prompt: ''},
      dropdownOpen: false,
      errorFeedback: {},
      isFormDisabled: true,
      prompt: !this.props.initialValues ? '' : this.props.initialValues.prompt,
      checkoffPrompt: !this.props.initialValues ? '' : this.props.initialValues.checkoffPrompt || 'I agree',
      requireAckResponse: !this.props.initialValues ? false : !!this.props.initialValues.requireAckResponse,
      isNotRequired: !this.props.initialValues ? false : !!this.props.initialValues.isNotRequired,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        prompt: this.state.prompt,
        checkoffPrompt: this.state.checkoffPrompt || 'I agree',
        isNotRequired: this.state.isNotRequired,
        requireAckResponse: this.state.requireAckResponse,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const {name, value} = event.target;
    this.props.touch(name);
    this.props.validateField(name, value, true);
  }

  handleInput(event) {
    const {name, value} = event.target;
    this.setState({[name]: value}, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit() {
    const properties = {
      prompt: this.state.prompt,
      checkoffPrompt: this.state.checkoffPrompt,
      requireAckResponse: this.state.requireAckResponse,
      isNotRequired: this.state.isNotRequired
    };
    this.props.onSave(properties);
  }

  updateRequireAckCommentField(val) {
    this.setState({
      requireAckResponse: val
    })
  }
  updateIsRequired(val) {
    this.setState({
      isNotRequired: val
    })
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <Card className="mb-3">
          <Form
            className="m-3"
            noValidate
            onSubmit={event => this.handleSubmit(event)}
          >
            <FormGroup>
              <Label for="prompt">Prompt *</Label>
              <Input
                className={this.state.cssValidationClasses.prompt}
                id="prompt"
                name="prompt"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Header"
                rows={2}
                type="textarea"
                value={this.state.prompt}
              />
              <FormFeedback>{this.state.errorFeedback.prompt}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="checkoffPrompt">Checkoff prompt</Label>
              <Input
                id="checkoffPrompt"
                name="checkoffPrompt"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Checkoff prompt"
                value={this.state.checkoffPrompt}
              />
              <FormFeedback>{this.state.errorFeedback.prompt}</FormFeedback>
            </FormGroup>
            <div className="mb-4">
              <Checkbox
                label="Is not required"
                checked={this.state.isNotRequired}
                onChange={e => this.updateIsRequired(e.target.checked)}
              />
            </div>
            <div className="mb-4">
              <Checkbox
                label="Require acknowledge comment"
                checked={this.state.requireAckResponse}
                onChange={e => this.updateRequireAckCommentField(e.target.checked)}
              />
            </div>
            <div>
              <LoadingButton
                primary
                text="Save"
                isLoading={this.props.isLoading}
                disabled={this.state.isFormDisabled}
                onClick={event => this.handleSubmit(event)}
              />
            </div>
          </Form>
        </Card>
      </Fragment>
    );
  }
}

export default withValidator(CheckoffFormCard, validatorConfig);
